<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">Register Petty Cash Deposit for '{{inner_User.name}} {{inner_User.familly}}'</h5>
      <form [formGroup]="FundsForm" (submit)="OnSubmit()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Deposited Amount (IRR) </label>
            <input formControlName="Price" (keyup)="pishPardakht_Change()" type="number" class="form-control" placeholder="Type here...">
            <small *ngIf="!get_Form_Dsc().valid && get_Form_Dsc().touched" class="form-text text-muted MyErrorRedColor">Enter the deposited amount (IRR).</small>
          </div>
          <div class="form-group col-md-8">
            <label for="exampleInputEmail1">Deposited Amount in Words </label>
            <input formControlName="PriceAlpah" disabled type="text" class="form-control">
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Deposit Date</label>
            <input type="text" formControlName="Date"  #datepickerBuy placeholder="Type here..."   class="form-control" />
            <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerBuy"></ng-persian-datepicker>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Description</label>
            <input formControlName="Dsc" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Dsc().valid && get_Form_Dsc().touched" class="form-text text-muted MyErrorRedColor">Enter the description.</small>
          </div>

        </div>
          <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
          <button *ngIf="!InProccessing" type="submit" [disabled]="!FundsForm.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
          <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-right: 5px;"><i class="fa fa-times-rectangle" ></i> Cancel </button>
      </form>

      <br/>
      <hr/>
      <br/>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>ID</th>
              <th>Deposited Amount (IRR)</th>
              <th>Deposit Date</th>
              <th>Description</th>
              <th>Created By</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Funds
            | paginate
                    : {
                        id: 'DataList_UserTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: DataList_Funds.length
                      }
            ">
             <td>{{DataList_Funds.indexOf(item)+1}}</td>
             <td>{{item.code}}</td>
             <td>{{item.price | number}}</td>
             <td>{{item.price_date}}</td>
             <td>{{item.dsc}}</td>
             <td>{{item.username}}</td>
             <td>{{item.subdate}}</td>

              <td>
                <div class="btn-group " role="group" aria-label="Button group with nested dropdown">
                  <div *ngIf="!item.del" class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          Actions
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                          <a style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item)"><i class="fa fa-remove"></i> Delete </a>
                      </div>
                  </div>

                  <div *ngIf="item.del" >
                    <p style="color: red;">Deleted</p>
                  </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>


     <pagination-controls
     id="DataList_UserTable"
     nextLabel="Next"
     previousLabel="Previous"
     (pageChange)="page = $event"
   ></pagination-controls>


  </div>
</div>


<ng-template #template>
  <div class="modal-header">
     <h4 class="modal-title pull-left">Delete Deposit ID '{{Data_Seleted_Delete.code}}' </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="Delete(Data_Seleted_Delete)"> Delete <i class="fa fa-remove"></i></button>
     <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">Close</button>
  </div>
</ng-template>
